var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGitlab = function SvgGitlab(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M-1.825-3.181h53.8v53.4h-53.8z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.95 49.01-24.2-17.6c-.3-.2-.6-.6-.7-1s-.1-.8 0-1.2l2.8-8.5zm-14.7-45.4 5.5 17.1H3.85l5.5-17.1c.1-.4.5-.6.9-.6.6-.1.9.2 1 .6zm5.5 17.1h18.4l-9.2 28.3zm34.2 8.6c.1.4.1.8 0 1.2s-.4.7-.7 1l-24.3 17.5 22.1-28.3zm-2.9-8.6h-12.8l5.5-17.1c.1-.4.5-.6.9-.6.5 0 .8.2.9.6z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGitlab);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTIiIGhlaWdodD0iNTIiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDUyIDUyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+LnN0MHtmaWxsOm5vbmU7fTwvc3R5bGU+PHJlY3QgY2xhc3M9InN0MCIgeD0iLTEuODI1IiB5PSItMy4xODA2IiB3aWR0aD0iNTMuOCIgaGVpZ2h0PSI1My40Ii8+PHBhdGggZD0ibTI1Ljk1IDQ5LjAxLTI0LjItMTcuNmMtMC4zLTAuMi0wLjYtMC42LTAuNy0xcy0wLjEtMC44IDAtMS4ybDIuOC04LjV6bS0xNC43LTQ1LjQgNS41IDE3LjFoLTEyLjlsNS41LTE3LjFjMC4xLTAuNCAwLjUtMC42IDAuOS0wLjYgMC42LTAuMSAwLjkgMC4yIDEgMC42em01LjUgMTcuMWgxOC40bC05LjIgMjguM3ptMzQuMiA4LjZjMC4xIDAuNCAwLjEgMC44IDAgMS4ycy0wLjQgMC43LTAuNyAxbC0yNC4zIDE3LjUgMjIuMS0yOC4zem0tMi45LTguNmgtMTIuOGw1LjUtMTcuMWMwLjEtMC40IDAuNS0wLjYgMC45LTAuNiAwLjUgMCAwLjggMC4yIDAuOSAwLjZ6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4K";